import styled from 'styled-components';

export const Termo = styled.div`
    position: relative;
    width : 90%;
    margin: 0 auto;
    font-family: "Exo 2","Arial";
`;

export const TermoBody = styled.div`

`;
